import { createClient, fetchExchange } from '@urql/core';
import { v4 as uuid } from 'uuid';

import { checkSharingSession, getSharingToken } from '/src/utils';
import { bearerAuthHeader } from '/src/utils/auth';
import { getStoredAccessToken } from '/src/services/token';

export const urqlOptions = (baseUrl) => {
  return {
    url: `${baseUrl || window.CORE_API_URL}/gql`,
    exchanges: [fetchExchange],
    fetchOptions: () => {
      const currentToken = checkSharingSession() ? getSharingToken() : getStoredAccessToken();
      return currentToken
        ? {
            headers: {
              ...bearerAuthHeader(currentToken),
              'x-request-id': uuid(),
            },
          }
        : {};
    },
  };
};

export const newClient = (options = urqlOptions()) => {
  return createClient(options);
};
